<div class="card card-tabs">
	<div class="card-body">
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<label for="" class="title-history">
				Informacion
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="information" [value]="0" checked id="tab1">
			<label for="tab1">
				<i class="fa fa-file-alt"></i>Administrativa
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="information" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2">
				<i class="fa fa-balance-scale"></i>Balance
			</label>

            <input type="radio" name="pcss3t" [(ngModel)]="information" [value]="2" id="tab3" class="tab-content-3">
			<label for="tab3">
				<i class="fa fa-chart-line"></i>Resultados
			</label>
		</div>
	</div>
	<app-administrative-information *ngIf="information == 0"></app-administrative-information>
	<app-balance-information *ngIf="information == 1"></app-balance-information>
    <app-results-information *ngIf="information == 2"></app-results-information>
</div>